/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

export default class SelectMenu extends Component {
  // passed in
  options = null; // array of { value, label, sublabel }

  selected = null; // currently selected value
  onChange = null; // action(value)

  // state
  @tracked
  isOpen = false;

  @action
  toggle() {
    this.toggleProperty('isOpen');
  }

  @action
  close() {
    this.isOpen = false;
  }

  @action
  select(value) {
    this.isOpen = false;
    if (this.onChange) {
      this.onChange(value);
    }
  }
}
